import {Component, HostListener, OnInit} from '@angular/core';
import { Decoder } from '../../model/decoder';
import { DecodersService } from '../../services/decoders.service';
import { DecoderFilters } from '../../model/filters/decoder-filters';
import { SortOrder } from '../../model/sort-order';
import { TenantsService } from '../../services/tenants.service';
import { TranslocoService } from '@ngneat/transloco';
import { ConfirmationService, MessageService } from 'primeng/api';
import { CommonMessagesService } from '../../services/common-messages.service';
import { AuthGuard } from '../../common/auth-guard.service';
import { Tenant } from '../../model/tenant';
import {FiltersService} from "../../services/filters.service";

@Component({
  selector: 'app-decoders',
  templateUrl: './decoders.component.html',
  styleUrls: ['./decoders.component.scss']
})
export class DecodersComponent implements OnInit {

  public decoders: Decoder[];
  public totalDecoders: number;
  public loadingDecoders: boolean;
  public tenants: Tenant[];

  public rows = 10;
  public first = 0;
  public selected = [];

  public filtersVisible: boolean;
  public currentFilters: DecoderFilters;
  public displayFailedDeleteList: boolean;
  public failedDeleteList: any[];
  public filtersFilled: boolean;

  constructor(private decodersService: DecodersService,
              private tenantsService: TenantsService,
              private messageService: MessageService,
              private i18n: TranslocoService,
              private confirmationService: ConfirmationService,
              public authGuardService: AuthGuard,
              private commonMessagesService: CommonMessagesService,
              private filtersService: FiltersService<DecoderFilters>) {
    this.currentFilters = new DecoderFilters();
  }

  ngOnInit(): void {
    if (this.filtersService.getCurrentFilters(this.constructor.name) !== undefined) {
      this.filtersFilled = true;
    }
    this.decoders = new Array(this.rows);
    if (this.authGuardService.superAdminRequired()) {
      this.tenantsService.getTenants().subscribe(response => {
        this.tenants = response.tenants
          .sort((a, b) => a.name > b.name ? 1 : -1);
        Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
      });
    } else {
      Object.assign(this.currentFilters, this.filtersService.getCurrentFilters(this.constructor.name));
    }
  }

  private loadDecoders(offset?: number, limit?: number): void {
    this.loadingDecoders = true;
    this.decoders = new Array(this.rows);
    this.trimFieldsForm(this.currentFilters);
    this.decodersService.getDecoders(offset, limit, this.filtersService.getCurrentFilters(this.constructor.name) === undefined ? this.currentFilters: this.filtersService.getCurrentFilters(this.constructor.name))
      .subscribe(response => {
        this.decoders = response.decoders;
        this.totalDecoders = response.totalElements;
        this.loadingDecoders = false;
      });
  }

  onPageChange(event): void {
    this.currentFilters.sortField = event.sortField;
    this.currentFilters.sortOrder = event.sortOrder < 0 ? SortOrder.DESCENDING : SortOrder.ASCENDING;
    this.loadDecoders(event.first / event.rows, event.rows);
  }

  resetFilters(): void {
    this.currentFilters = new DecoderFilters();
    this.currentFilters.sortField = 'name';
    this.currentFilters.sortOrder = SortOrder.ASCENDING;
    this.filtersFilled = false;
    this.filtersService.setCurrentFilters(undefined, this.constructor.name);
    this.applyFilters(true);
  }

  applyFilters(reset?: boolean): void {
    this.first = 0;
    if (reset !== true){
      this.filtersService.setCurrentFilters(this.currentFilters, this.constructor.name);
      this.filtersFilled = true;
    }
    this.loadDecoders(this.first / this.rows, this.rows);
  }

  confirmAndDelete(decoder: Decoder): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => {
      this.deleteDecoder(decoder.tenant.uuid, decoder.name);
    });
  }

  deleteDecoder(tenantUuid: string, name: string): void {
    this.tenantsService.deleteTenantDecoder(tenantUuid, name).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadDecoders(this.first / this.rows, this.rows);
    }, error => {
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status);
    });
  }

  confirmAndDeleteSelected(): void {
    this.commonMessagesService.showDeleteRequestConfirmation(() => this.deleteSelected(), true);
  }

  deleteSelected(): void {
    if (this.selected.length === 0) { return; }
    const identifiers = this.selected.map(item => ({tenantUuid: item.tenant.uuid, name: item.name}));

    this.decodersService.deleteDecoders(identifiers).toPromise().then(() => {
      this.commonMessagesService.showSuccessfullyDeletedMessage();
      this.loadDecoders(this.first / this.rows, this.rows);
    }, error => {
      this.failedDeleteList = error.error.decodersBeingUsed;
      this.displayFailedDeleteList = true;
      this.commonMessagesService.showErrorWhileDeletingMessage(error.status, true);
    });
  }

  trimFieldsForm(filters: DecoderFilters): void {
    Object.keys(filters).forEach((key) => {
      if (filters[key] !== undefined && typeof filters[key] === 'string') {
        filters[key] = filters[key].trim();
      }
    });
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent): void {
    if (event.key === 'f') {
      this.filtersVisible = true;
    }
    if (event.key === 'Escape') {
      this.filtersVisible = false;
    }
  }

}
